import React, { useReducer } from 'react';
import axios from 'axios';
//import uuid from 'uuid';
import ClientsContext from './clientsContext';
import clientsReducer from './clientsReducer';
import {
  GET_CLIENTS,
  CLEAR_CLIENTS,
  ADD_CLIENT,
  DELETE_CLIENT,
  SET_CURRENT,
  CLEAR_CURRENT,
  UPDATE_CLIENT,
  FILTER_CLIENTS,
  CLEAR_FILTER,
  CLIENT_ERROR
} from '../types';

const ClientsState = props => {
  const initialState = {
    clients: null,
    current: null,
    filtered: null,
    error: null
  };

  const [state, dispatch] = useReducer(clientsReducer, initialState);

  // Get Clients
  const getClients = async () => {
    try {
      const res = await axios.get('/api/v1/clients');
      dispatch({
        type: GET_CLIENTS,
        payload: res.data
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: CLIENT_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Add Client
  const addClient = async client => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    try {
      const res = await axios.post('/api/v1/clients', client, config);
      dispatch({
        type: ADD_CLIENT,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: CLIENT_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Delete Client
  const deleteClient = async id => {
    try {
      await axios.delete(`/api/v1/clients/${id}`);
      dispatch({
        type: DELETE_CLIENT,
        payload: id
      });
    } catch (err) {
      dispatch({
        type: CLIENT_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Update Client
  const updateClient = async client => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    //console.log('userStateUpdateClient', user);
    try {
      const res = await axios.put(
        `/api/v1/clients/${client.id}`,
        client,
        config
      );

      dispatch({
        type: UPDATE_CLIENT,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: CLIENT_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Clear Clients
  const clearClients = () => {
    dispatch({ type: CLEAR_CLIENTS });
  };

  //Set Current Client
  const setCurrent = client => {
    dispatch({ type: SET_CURRENT, payload: client });
  };

  //Clear Current User

  const clearCurrent = () => {
    dispatch({ type: CLEAR_CURRENT });
  };

  //Filter Users
  const filterClients = text => {
    dispatch({ type: FILTER_CLIENTS, payload: text });
  };

  //Clear Filter
  const clearFilter = () => {
    dispatch({ type: CLEAR_FILTER });
  };

  return (
    <ClientsContext.Provider
      value={{
        clients: state.clients,
        current: state.current,
        filtered: state.filtered,
        error: state.error,
        getClients,
        addClient,
        deleteClient,
        setCurrent,
        clearCurrent,
        updateClient,
        filterClients,
        clearFilter,
        clearClients
      }}
    >
      {props.children}
    </ClientsContext.Provider>
  );
};

export default ClientsState;
